/* eslint-disable max-len */
import type { FC } from "react";

import type { IconProps } from "./BaseIcon";
import { BaseIcon } from "./BaseIcon";

export const ImportIcon: FC<IconProps> = (props) => {
  return (
    <BaseIcon {...props}>
      <path d="m11.22 16.625 3.986 4.983a1.005 1.005 0 0 0 .364.295 1.002 1.002 0 0 0 1.224-.295l3.987-4.983a1 1 0 1 0-1.562-1.25L17 18.15V4a1 1 0 1 0-2 0v14.15l-2.22-2.775a1 1 0 1 0-1.56 1.25ZM6 13v12h20V13h-1a1 1 0 1 1 0-2h2a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V12a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2H6Z" />
    </BaseIcon>
  );
};
